<template>
  <div class="location">
    <div><h2 style="letter-spacing: 20px;">LOCATION MAP</h2></div>
    <div style="width:80%;height:80%;position: relative;">
      
      <div style="width: 100%;height: 100%;display: flex;">
        <div style="width: 70%;height: 100%;">
          <motion v-bind:zoomsize="zoomsizes" @setzoomsize="setzoomsize" :index="index" :btn="false">
            <img ondragstart="return false;" style="max-width: 100%;max-height: 100%;" :src="GLOBAL.imgserve+'/location.png'" alt="">
          </motion>
        </div>

        <div style="width: 30%;height: 100%;">
        <img style="max-width: 100%;max-height: 100%;" :src="GLOBAL.imgserve+'/locationright.png'" alt="">
          
        </div>
      </div>

 
      <div style="position: absolute;width: 100%;">
          <div style="position: absolute;bottom: 0px;left: 0px;font-size: .5rem;">
            This map is to scale in reference from google map.
          </div>
          <div class="btn" style="font-weight: 600;background: white;color: black;width: 200px;margin: auto;"
            @click="setpop(true)"
          >
            DRONE LINK
          </div>
      </div>

    </div>
    <div class="pop" v-show="poptype">
      <iframe style="  width: 100%;height: 100%;" src="https://www.mixgovr.com/AUDAX/PPH-Drone/" frameborder="0"></iframe>
      <div class="back btn"  @click="setpop(false)"><img  :src="GLOBAL.imgserve+'/btn/X.png'" alt=""></div>

    </div>
  </div>
</template>

<script>
import motion from "@/components/motion.vue";

export default {
  	  components: {
    motion,
  },
  data() {
    return {
      			w:100,
			h:100,
      poptype:false,
      zoomsizes: 1,
			index:0

    }
  },

  methods:{

    setpop(vl){
      this.poptype =  vl
    },
        setzoomsize(data) {
      this.zoomsizes = data;
    },
  }

}
</script>




<style >
  
.location{
  width: 100%;
  height: 100%;
  overflow:auto;
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
}


.pop{
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 100;
}


</style>


